import { FC } from "react";
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";
import RenderCircleItem from "./RenderCircle";
import { DifferentViewComponentProps } from "./type";
import { cn } from "~/lib/utils";
import { DISPLAY_TYPE } from "./video-data";

const Circle: FC<DifferentViewComponentProps> = ({ data, url_slug }) => {
  // console.log('data: ', data);
  return data.length ? (
    <>
      {/* Mobile Carousel - visible only on mobile screens */}
      <div className="block my-3 lg:mb-0 lg:hidden">
        <Carousel
          opts={{
            align: "start",
            loop: false,
            dragFree: true,
            containScroll: "trimSnaps",
          }}
          className="w-full"
        >
          <CarouselContent className="p-3">
            {data.map((item) => (
              <CarouselItem key={item.id} className="pl-2 xs:basis-2/4 smd:basis-2/6 sml:basis-2/6 md:basis-2/6">
                <RenderCircleItem isBranch={item.node_type === DISPLAY_TYPE.branch} item={item} url_slug={url_slug || null} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>

      {/* Desktop Grid - visible only on desktop screens */}
      <div className={cn("hidden sm:grid sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-7 gap-3 sm:gap-4 md:gap-4 lg:gap-5  ")}>
        {data.map((item) => (
          <div key={item.id}>{<RenderCircleItem isBranch={item.node_type === DISPLAY_TYPE.branch} item={item} url_slug={url_slug || null} />}</div>
        ))}
      </div>
    </>
  ) : null;
};

export default Circle;
